import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  constructor(private http: HttpClient) { }
  getDashboardDetails(id: any) {
    return this.http.get(urls.API_URL + urls.COMPANIES + `/${id}/` + urls.DASHBOARD)
      .pipe(catchError(errorHandl));
  }
  
}

